import Enum from "./Enum";

export default Enum.create( {
	MANAGER_FEEDBACK: "Manager Feedback",
	LONG_TERM_GOALS: "Long-Term Goals",
	CAREER_ADVANCEMENT: "Career Advancement",
	PERSONAL_ROLE_ALIGNMENT: "Personal Role Alignment",
	PERFORMANCE_AND_BEHAVIORAL_IMPROVEMENT: "Performance & Behavioral Improvement",
	ICEBREAKERS: "Icebreakers",
	TEAM_AND_COWORKER_RELATIONSHIPS: "Team & Coworker Relationships",
	TOOLS_RESOURCES_AND_ENVIRONMENT: "Tools, Resources & Environment",
	PERSONAL_RECOGNITION: "Personal Recognition",
	NEAR_TERM_GOALS: "Near-term Goals",
	PROGRESS_CHECK: "Progress Check",
	CHANGE_MANAGEMENT: "Change Management",
	COMPANY_CULTURE: "Company Culture",
	WORKLOAD: "Workload",
	WORK_LIFE_BALANCE: "Work-Life Balance",
	PROCESS_AND_WORKFLOW: "Process & Workflow",
	PROFESSIONAL_DEVELOPMENT: "Professional Development",
	ENGAGEMENT_AND_RETENTION: "Engagement & Retention",
	ORGANIZATIONAL_ALIGNMENT: "Organizational Alignment",
} );
